export interface PickFileOptions {
  accept?: string;
}

export function pickFile({ accept = '.xlsx,.xls,.csv' }: PickFileOptions = {}): Promise<File | null> {
  return new Promise((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.style.display = 'none';
    document.body.appendChild(input);

    const cleanup = () => {
      document.body.removeChild(input);
    };

    input.onchange = () => {
      resolve(input.files?.[0] ?? null);
      cleanup();
    };

    // Handle cancel: when focus returns to the window without a file selection
    const handleFocus = () => {
      window.removeEventListener('focus', handleFocus);
      setTimeout(() => {
        if (!input.files?.length) {
          resolve(null);
          cleanup();
        }
      }, 300);
    };
    window.addEventListener('focus', handleFocus);

    input.click();
  });
}
